<template>
  <div class="past_awards-photo_album">

    <h3 class="mb-2"><strong>{{ submission['title'] }}</strong> - <em>{{ submission['location'] }}</em></h3>
    <div class="single_album">
      <div class="album_images">
        <img v-for="(image, index) in Object.values(submission['images'])"
             :src="image"
             :key="index"
        />
      </div>
      <AwardsSubmissionRating :submission="submission"
                              :has_comment="has_comment"
                              submission_method="photo_album"
                              @check-comments="check_comments = true"
                              class="ml-4"
      />
      <div class="single_awards_action ml-2" v-if="has_comment && show_comments">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" @click="openDialog('comments')">
              <v-icon class="notranslate">comment</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('awards.read_comments') }}</span>
        </v-tooltip>
        <span class="btn_label">{{ $t('comments_label') }}</span>
      </div>
      <div class="single_awards_action ml-2" v-if="parseInt(submission['rating'], 10) >= 1">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on"
                   :color="review_info['color']"
                   @click="openDialog((submission['review'] && submission['review']['analysis_status'] === 'done') ? 'read_review' : 'request_review')">
              <v-icon class="notranslate">image_search</v-icon>
            </v-btn>
          </template>
          <span>{{ review_info['text'] }}</span>
        </v-tooltip>
        <span class="btn_label">{{ $t('review_label') }}</span>
      </div>
      <div class="single_awards_action ml-2" v-if="(can_dispute && parseInt(submission['rating'], 10) >= 1) || submission['dispute'] !== ''">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on"
                   :color="dispute_info['color']"
                   @click="openDialog((submission['dispute'] && submission['dispute']['analysis_status'] === 'done') ? 'read_dispute' : 'open_a_dispute')">
              <v-icon class="notranslate">report</v-icon>
            </v-btn>
          </template>
          <span>{{ dispute_info['text'] }}</span>
        </v-tooltip>
        <span class="btn_label">{{ $t('dispute_label') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import AwardsSubmissionRating from './AwardsSubmissionRating'
import { confirmed_status } from '../utils/rules'
export default {
  name: 'PastAwardsPhotoAlbum',
  components: { AwardsSubmissionRating },
  props: {
    submission: {
      type: Object,
      required: true
    },
    can_dispute: {
      type: Boolean,
      required: true
    },
    show_comments: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    admin_comment: function () {
      return this.submission['admin_comment']
    },
    judges_comments: function () {
      return Object.values(this.submission['judges_comments']).filter(
        el => el.visible
      ).map(
        el => el.comment
      )
    },
    has_comment: function () {
      return (this.admin_comment !== '' || this.judges_comments.length >= 1)
    },
    review_info: function () {
      if (this.submission['review'] === '') {
        return {
          text: this.$t('awards.request_review'),
          color: 'none'
        }
      } else {
        if (confirmed_status.includes(this.submission['review']['payment_status'])) {
          return (this.submission['review']['analysis_status'] === 'pending')
            ? {
              text: this.$t('review_in_analysis'),
              color: 'info'
            }
            : {
              text: this.$t('review_done'),
              color: 'success'
            }
        } else {
          return {
            text: this.$t('review_payment_not_confirmed'),
            color: 'error'
          }
        }
      }
    },
    dispute_info: function () {
      if (this.submission['dispute'] === '') {
        return {
          text: this.$t('awards.open_a_dispute'),
          color: 'none'
        }
      } else {
        if (confirmed_status.includes(this.submission['dispute']['payment_status'])) {
          return (this.submission['dispute']['analysis_status'] === 'pending')
            ? {
              text: this.$t('dispute_in_analysis'),
              color: 'info'
            }
            : {
              text: this.$t('dispute_done'),
              color: 'success'
            }
        } else {
          return {
            text: this.$t('dispute_payment_not_confirmed'),
            color: 'error'
          }
        }
      }
    }
  },
  methods: {
    openDialog: function (type) {
      if (type === 'read_review') {
        this.$router.push(`/reviews/${this.submission['review']['post_id']}`)
      } else if (type === 'read_dispute') {
        this.$router.push(`/disputes/${this.submission['dispute']['post_id']}`)
      } else {
        if (
          !(type === 'request_review' && this.submission['review'] !== '') &&
          !(type === 'open_a_dispute' && this.submission['dispute'] !== '')
        ) {
          this.$emit('open-dialog',
            type,
            this.$vnode.key,
            this.submission['thumbnail'],
            this.admin_comment,
            this.judges_comments,
            this.submission['title'],
            this.submission['location']
          )
        } else {
          const raw_type = type === 'request_review' ? 'review' : 'dispute'
          this.$emit('open-requested-dialog',
            type,
            this.$vnode.key,
            this.submission['thumbnail'],
            this.submission[raw_type],
            this.submission['title'],
            this.submission['location']
          )
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .comment_quote {
    margin: 12px 0 12px 12px;
    font-size: 16px;
    color: rgba(0,0,0,0.54);
    font-style: italic;
    &::before,
    &::after{
      content: '"';
      font-size: 18px;
      font-weight: bold;
    }
  }
  .comment_quote + .headline {
    margin-top: 12px;
  }
  .past_awards-photo_album {
    margin: 48px auto;
    max-width: 1200px;
    h3 {
      color: rgba(0,0,0,0.87);
      font-weight: normal;
    }
    .single_album {
      display: flex;
      justify-content: center;
      align-items: center;
      .album_images {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        grid-template-rows: auto;
        grid-gap: 4px;
        flex: 1;
        img {
          display: block;
          width: 100%;
          height: auto;
        }
      }
      .single_awards_action {
        display: flex;
        flex-direction: column;
        align-items: center;
        .v-btn {
          width: 32px;
          height: 32px;
          margin: 0;
        }
        .btn_label {
          font-size: 12px;
          line-height: 14px;
          color: rgba(0,0,0,0.54);
        }
      }
    }
  }
</style>

<i18n>
  {
    "en": {
      "comments_label": "Comments",
      "review_label": "Review",
      "dispute_label": "Dispute",
      "review_in_analysis": "Review requested, collection in analysis",
      "review_done": "Review completed, read here",
      "review_payment_not_confirmed": "Payment not yet confirmed",
      "dispute_in_analysis": "Dispute requested, collection in analysis",
      "dispute_done": "Dispute completed, read here",
      "dispute_payment_not_confirmed": "Payment not yet confirmed"
    },
    "pt": {
      "comments_label": "Comentários",
      "review_label": "Análise",
      "dispute_label": "Contestação",
      "review_in_analysis": "Análise crítica solicitada, coleção em análise",
      "review_done": "Análise crítica concluída, leia aqui",
      "review_payment_not_confirmed": "Pagamento ainda não confirmado",
      "dispute_in_analysis": "Contestação solicitada, coleção em análise",
      "dispute_done": "Contestação concluída, leia aqui",
      "dispute_payment_not_confirmed": "Pagamento ainda não confirmado"
    }
  }
</i18n>
